import { render, staticRenderFns } from "./secretaryList.vue?vue&type=template&id=48912ea7&scoped=true&"
import script from "./secretaryList.vue?vue&type=script&lang=js&"
export * from "./secretaryList.vue?vue&type=script&lang=js&"
import style0 from "./secretaryList.vue?vue&type=style&index=0&id=48912ea7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48912ea7",
  null
  
)

export default component.exports